
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19.743","height":"14.852"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-width":"2"}},[_c('path',{attrs:{"d":"M17.159 1H6.864L1.321 7.426l5.543 6.426h10.295a1.6 1.6 0 001.584-1.607V2.607A1.6 1.6 0 0017.159 1z"}}),_c('path',{attrs:{"stroke-linejoin":"round","d":"M14.743 5l-5 5M9.743 5l5 5"}})])])
          )
        }
      }
    